module.exports = __webpack_public_path__ + "static/media/icon-moduleE8.feb65d25.png";